<template>
  <div id="productModal">     
    <!-- Modal content -->
    <div class="product-modal-content">
      <span class="close">&times;</span>
      <ul>
        <li v-for="(item, index) in getQuotation" class="quote-item">
          {{ item.title }}
          <i
          class="fas fa-times" 
          style="float:right;cursor:pointer;"
          @click="removeItem(index)"></i></li>
        </li>
      </ul>
      <div>
        <button 
        style="width:100%;margin: 10px 0;padding: 8px 0;border-radius:4px;background-color: #43a553;color:#fff;font-size:16px;border: none;cursor:pointer"
        @click="quotationModal">Solicitar cotización</button>
      </div>
      <hr>
      <div style="padding-top: 10px;">         
        
        <button v-if="!auth" @click="showLogin" class="login-btn">
          <i class="fas fa-user-circle"></i>Iniciar sesión
        </button>

        <button v-else @click="onLogout" class="login-btn">Salir</button>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  // props: ['product'],
  computed: {
    auth () {
      return this.$store.getters.isAuthenticated
    }
  },
  methods: {
    showLogin () {
      // this.showModal = true
      // this.showQuote = false

      this.$store.commit('show')
    }
  }
};
</script>


<style scoped>
/* The Modal (background) */
#productModal {

  position: fixed; /* Stay in place */
  z-index: 9999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.5); /* Black w/ opacity */
  transition: opacity .3s ease;
}


/* Modal Content/Box */
.product-modal-content {
  background-color: #fefefe;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 5% auto;  
  /*margin-top: 15%;*/
  /*padding: 20px;*/
  /*border: 1px solid #888;*/
  width: 80%; /* Could be more or less, depending on screen size */
}

.modal-content-wrapper {
  padding: 30px;
}

.form-product-container {
  /*background-color: rgba(0,0,0,0.4);*/
  padding: 0 !important;
}

/* The Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  display: none;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.product-info {
  font-size: 20rem;
}

.document-link-container {
  padding: 20px 0;
}

.product-info-item {
  padding: 8px 0;
  font-size: 18px;
}

.product-info-item span{
  font-weight: bold;
}

.product-document {
  color: #43a553;
  cursor: pointer;
  text-decoration: underline;
}

</style>